export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/tags', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/tag', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/tag/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/tag/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/tag/' + data.id, { params: data.filters || {} })
  }
})
